import {
	CurrencyRestrictionsType,
	SetCurrencyRestrictionsAction,
	CurrencyRestrictions,
} from './CurrencyRestrictionsTypes';

const initialState: { currencyRestrictions: CurrencyRestrictions[] } = {
	currencyRestrictions: [],
};

export default (state = initialState, action: SetCurrencyRestrictionsAction) => {
	switch (action.type) {
		case CurrencyRestrictionsType.SET_CURRENCY_RESTRICTIONS:
			return {
				...state,
				currencyRestrictions: action.data,
			};
		default:
			return state;
	}
};
